export const LOAD_DATA_START = 'data/loadStart';
export const LOAD_DATA_DONE = 'data/loadDone';
export const LOAD_DATA_FAIL = 'data/loadFail';

export const LOAD_DATA_LIST_START = 'data/loadListStart';
export const LOAD_DATA_LIST_DONE = 'data/loadListDone';
export const LOAD_DATA_LIST_FAIL = 'data/loadListFail';